import { render } from "./ProductionOrderInfosModal.vue?vue&type=template&id=bd5cb9b6&ts=true&lang=pug"
import script from "./ProductionOrderInfosModal.vue?vue&type=script&lang=ts"
export * from "./ProductionOrderInfosModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__